import React from 'react';
import './ProofStrip.css';

const proofs = [
    'Smart India Hackathon ’25 · 1st of 68,766 teams',
    'Smart India Hackathon ’24 · National Winner',
    'Google Summer of Code ’26 · NOAA / IOOS',
    'CPO · Reltin by Assetary',
    'Post-Athon Winner · India Post',
    'Google Dev Sprint ’25 · Runner-Up',
    '3× sales growth shipped · Forest Naturals',
];

function ProofStrip() {
    const renderItems = (ariaHidden) => (
        <div className="proof-track-segment" aria-hidden={ariaHidden || undefined}>
            {proofs.map((item, i) => (
                <span className="proof-item" key={i}>
                    <span className="proof-star" aria-hidden="true">✦</span>
                    {item}
                </span>
            ))}
        </div>
    );

    return (
        <div className="proof-strip" aria-label="Highlights">
            <div className="proof-track">
                {renderItems(false)}
                {renderItems(true)}
            </div>
        </div>
    );
}

export default ProofStrip;
